/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Connection_Key_RequiredInputs */



/**
* | output |
* | --- |
* | "API key is required" |
*
* @param {Private_Models_Connection_Key_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_connection_key_required = /** @type {((inputs?: Private_Models_Connection_Key_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Connection_Key_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("API-Schlüssel ist erforderlich")
	return /** @type {LocalizedString} */ ("API key is required")
});